import React, { Fragment, useState } from "react";
import { cdnImg } from "../../../Utils/cdnImage";
import useSelectionLogic from "../../useLogic/useSelectionLogic";
import useScrollToItem from "../../../component/Scroll";
import BetSlipContext from "../../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import RenderOddsSkyWeb from "./RenderOdds";
import { isNumber } from "lodash";

const BetFair = ({
  object,
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  ms,
  marketId,
  totalMatched,
  detail,
  user,
  profileData,
  typeGame,
  marketName,
  position,
}) => {
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });

  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const [localLimit, setLocalLimit] = useState({});
  const scrollToItem = useScrollToItem("#header"); // Pass header selector
  const { handelChange, checkArrays } = useSelectionLogic({
    user: user,
    profileData: profileData,
    detail: detail,
    typeGame: typeGame,
    marketId: marketId,
    totalMatched: totalMatched,
    setLocalLimit,
    scrollToItem,
    localLimit,
    marketName,
  });

  return (
    <div
      id="fullMarketBetsWrap"
      className={`bets-wrap asiahadicap ${ms != 1 ? "disabled" : ""} `}
    >
      <span id="selectionCounts" className="refer_only">
        {marketName != "Match Odds" && marketName} {runner?.length} selections
      </span>
      <table id="fullMarketBoard" className="bets">
        <tbody>
          <tr className="bet-all">
            <td />
            <td id="backPercent" className="refer-bet" colSpan={2}>
              100.6%
            </td>
            <td>
              <a id="backAll" className="back-all">
                <img src={cdnImg("/assets/images/transparent.gif")} />
                <span>Back all</span>
              </a>
            </td>
            <td>
              <a id="layAll" className="lay-all">
                <img src={cdnImg("/assets/images/transparent.gif")} />
                <span>Lay all</span>
              </a>
            </td>
            <td id="layPercent" className="refer-book" colSpan={2}>
              99.2%
            </td>
          </tr>

          {runner?.map((item, index) => {
            let odds_back = backOdds
              ?.filter((t) => t.ri === item.SelectionId)
              ?.sort((a, b) => a.rt - b.rt);

            let odds_lay = layOdds
              ?.filter((t) => t.ri === item.SelectionId)
              ?.sort((a, b) => b.rt - a.rt);

            let old_back = oldBack
              ?.filter((t) => t.ri === item.SelectionId)
              ?.sort((a, b) => a.rt - b.rt);

            let old_lay = oldLay
              ?.filter((t) => t.ri === item.SelectionId)
              ?.sort((a, b) => b.rt - a.rt);

            let disabelBack =
              "lockBackBets" in item ? item?.lockBackBets : false;
            let disabelLay = "lockLayBets" in item ? item?.lockLayBets : false;

            const limitOdds = localLimit?.oddsLimit ?? 0;

            const backLimitExceeded = odds_back?.some((o) => o.rt > limitOdds);
            const layLimitExceeded = odds_lay?.some((o) => o.rt > limitOdds);

            const finalDisableBack = disabelBack || backLimitExceeded;
            const finalDisableLay = disabelLay || layLimitExceeded;

            const disableFull = checkArrays(
              odds_back, // FULL array
              odds_lay, // FULL array
              localLimit // full limit object
            );

            let showPosition =
              (isNumber(item?.position) &&
                position?.length > 0 &&
                Math.abs(item?.position) > 0) ||
              (Math.abs(item?.newPosition) >= 0 &&
                showBetDialog &&
                betSlipObject?.playType == typeGame &&
                marketId == betSlipObject?.object?.newMarketId);
            return (
              <Fragment>
                <tr
                  style={{ display: "table-row" }}
                  className={disableFull ? "disabled" : ""}
                >
                  <th className="predict">
                    <p>
                      <a>
                        <img
                          className="icon-predict"
                          src={cdnImg("/assets/images/transparent.gif")}
                        />
                      </a>
                      {item?.RunnerName || item?.runnerName}
                    </p>
                    {isNumber(item?.position) &&
                      position?.length > 0 &&
                      Math.abs(item?.position) > 0 && (
                        <span
                          id="withoutBet"
                          className={item?.position > 0 ? "win" : "lose"}
                        >
                          {isNumber(item?.position) &&
                          Math.abs(item?.position) > 0
                            ? item?.position > 0
                              ? Math?.abs(item?.position).toFixed(2)
                              : `(${Math.abs(item?.position).toFixed(2)})`
                            : ""}
                        </span>
                      )}
                    {Math.abs(item?.newPosition) >= 0 &&
                      showBetDialog &&
                      betSlipObject?.playType == typeGame &&
                      marketId == betSlipObject?.object?.newMarketId && (
                        <span
                          id="withBet"
                          className={`to-${
                            item?.newPosition > 0 ? "win" : "lose"
                          }`}
                        >
                          {item?.newPosition > 0
                            ? Math.abs(item?.newPosition).toFixed(2)
                            : `(${Math.abs(item?.newPosition).toFixed(2)})`}
                        </span>
                      )}
                  </th>

                  <RenderOddsSkyWeb
                    component={typeGame}
                    index={index}
                    marketName={marketName}
                    item={item}
                    disabelBack={
                      disableFull || ms != 1 ? false : finalDisableBack
                    }
                    disabeLay={disableFull || ms != 1 ? false : finalDisableLay}
                    oldBack={old_back}
                    oldLay={old_lay}
                    disableFull={disableFull || ms != 1}
                    disabelLay={detail?.market == "Win" ? true : disabelLay}
                    isInPlay={
                      ["Win", "Winner"].includes(detail?.market)
                        ? true
                        : detail?.status == "in_play"
                        ? true
                        : false
                    }
                    handelChange={handelChange}
                    odds_lay={odds_lay}
                    odds_back={odds_back}
                    limit={localLimit}
                    ms={ms}
                    betType={betSlipObject?.betType}
                    indexObject={betSlipObject?.index}
                    active={
                      showBetDialog &&
                      marketId == betSlipObject?.newMarketId &&
                      item?.SelectionId == betSlipObject?.object?.SelectionId &&
                      typeGame == betSlipObject?.playType
                    }
                  />
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BetFair;
